import { FcmEntry, RequestingProgress } from ".";
import { Languages } from "../utils";
import { PaymentStatus } from "./paid";

export interface UserState extends RequestingProgress {
  user: User | null;
}

export interface User {
  id: number;
  name: string;
  street: string;
  estateNo: string;
  city: string;
  wcpid: number;
  paymentStatus: PaymentStatus;
  language: Languages;
  devices: FcmEntry[];
  administrationName?: string;
  administrationNameHungarian?: string;
}

export const defaultNotificationTime = 12;
export const defaultNotificationAheadTime = 24;
